import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { api } from '../../state/auth.js';
import { openFile } from '../../utils/openFile.js';

// Documenten, in a club housed at a sportcomplex: what the complex shared with this
// member, as a folder with the complex's name (read only). Nothing shared: no folder.

const size = bytes => (bytes > 1048576 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((bytes || 0) / 1024))} kB`);
const isHttp = url => /^https?:\/\//i.test(url || '');
const BUTTON = 'padding:5px 9px;font-size:11px;border:1px solid var(--color-border);border-radius:6px;background:var(--color-bg);color:var(--color-text);cursor:pointer;white-space:nowrap;text-decoration:none';

export default function ComplexSharedDocuments() {
  const [shared, setShared] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api('/api/complexes/shared/documents').then(setShared).catch(() => setShared(null)); }, []);
  if (!shared?.complex || !shared.documents.length) return null;
  return (
    <div style="border:1px solid var(--color-border);border-radius:12px;background:var(--color-surface);margin-bottom:16px;overflow:hidden">
      <button onClick={() => setOpen(o => !o)} aria-expanded={open}
        style="display:flex;align-items:center;gap:10px;width:100%;padding:12px 16px;border:none;background:transparent;color:var(--color-text);cursor:pointer;text-align:left;font-size:14px;font-weight:600">
        <span style="font-size:18px">🏟</span>
        <span style="flex:1;min-width:0">{shared.complex.name}</span>
        <span style="font-size:12px;font-weight:400;color:var(--color-text-muted)">{shared.documents.length} gedeeld door het complex</span>
        <span aria-hidden="true">{open ? '▾' : '▸'}</span>
      </button>
      {open && shared.documents.map(d => (
        <div key={d.id} style="display:flex;align-items:center;gap:10px;padding:10px 16px;border-top:1px solid var(--color-border);flex-wrap:wrap">
          <div style="flex:1 1 200px;min-width:0">
            <div style="font-size:13px;font-weight:600;overflow-wrap:anywhere">{d.file_name}</div>
            <div style="font-size:11px;color:var(--color-text-muted)">
              {[d.description, d.is_external ? 'Externe link' : size(d.file_size), d.complex_audience === 'besturen' && 'voor besturen'].filter(Boolean).join(' · ')}
            </div>
          </div>
          {d.is_external
            ? (isHttp(d.external_url) && <a href={d.external_url} target="_blank" rel="noopener noreferrer" style={BUTTON}>↗ Openen</a>)
            : (
              <>
                <button style={BUTTON} onClick={() => openFile(`/api/complexes/shared/documents/${d.id}/preview`, d.file_name)}>👁 Bekijk</button>
                <button style={BUTTON} title="Download" onClick={() => openFile(`/api/complexes/shared/documents/${d.id}/download`, d.file_name)}>⬇</button>
              </>
            )}
        </div>
      ))}
    </div>
  );
}
